export default () => {
    const header = document.querySelector<HTMLElement>('#header-outer')
    const infoBar = document.querySelector<HTMLElement>('.js-info-bar')
    const wpAdminBar = document.querySelector<HTMLElement>('#wpadminbar')

    if (!header || !infoBar) return

    const mq = window.matchMedia('(min-width: 770px)')

    const apply = () => {
        if (!mq.matches) {
            infoBar.style.top = '0'
            return
        }

        infoBar.style.top = `${header.offsetHeight + (wpAdminBar?.offsetHeight ?? 0)}px`
    }

    apply()

    const ro = new ResizeObserver(apply)
    ro.observe(header)

    mq.addEventListener('change', apply)
}
